import React, { useState } from "react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import {
  Ticket,
  UserPlus,
  Gift,
  CircleAlert,
  ChevronRight,
} from "lucide-react";

const shortCuts = [
  {
    id: 2,
    title: "Request Team Member",
    description: "Request to hire a new team member for your department",
    color: "purple",
    icon: <UserPlus className="w-6 h-6 text-white" />,
    route: "/console/recruitment-overview#Request",
  },
  // {
  //   id: 1,
  //   title: "Ticket Request",
  //   description: "Submit a support ticket for technical or HR assistance",
  //   color: "blue",
  //   icon: <Ticket className="w-6 h-6 text-white" />,
  //   route: "/console/it-support",
  // },
  // {
  //   id: 3,
  //   title: "Reward Team Member",
  //   description: "Recognize and reward outstanding team contributions",
  //   color: "amber",
  //   icon: <Gift className="w-6 h-6 text-white" />,
  //   route: "/console/hyvid-awards",
  // },
  // {
  //   id: 4,
  //   title: "Action Required",
  //   description: "Leave approvals, overdue bills & pending tasks",
  //   color: "red",
  //   icon: <CircleAlert className="w-6 h-6 text-white" />,
  //   route: "/console/dashboard#action-required"
  // },
];

const colorMap = {
  blue: {
    light: "from-blue-50 to-white dark:from-blue-900 dark:to-intsamis-800",
    border: "border-blue-200 dark:border-blue-700",
    header: "from-blue-500 to-blue-600 shadow-blue-500/30",
    text: "text-blue-900 dark:text-blue-50",
    desc: "text-blue-700 dark:text-blue-200",
    chevron: "text-blue-600 dark:text-blue-500",
  },
  purple: {
    light: "from-purple-50 to-white dark:from-purple-900 dark:to-intsamis-800",
    border: "border-purple-200 dark:border-purple-700",
    header: "from-purple-500 to-purple-600 shadow-purple-500/30",
    text: "text-purple-900 dark:text-purple-50",
    desc: "text-purple-700  dark:text-purple-200",
    chevron: "text-purple-600 dark:text-purple-500",
  },
  amber: {
    light: "from-amber-50 to-white dark:from-amber-900 dark:to-intsamis-800",
    border: "border-amber-200 dark:border-amber-700",
    header: "from-amber-500 to-orange-500 shadow-amber-500/30",
    text: "text-amber-900  dark:text-amber-50",
    desc: "text-amber-700 dark:text-amber-200",
    chevron: "text-amber-600 dark:text-amber-500",
  },
  red: {
    light: "from-red-50 to-white dark:from-red-900 dark:to-intsamis-800",
    border: "border-red-200 dark:border-red-700",
    header: "from-red-500 to-red-600 shadow-red-500/30",
    text: "text-red-900 dark:text-red-100" ,
    desc: "text-red-700 dark:text-red-200",
    chevron: "text-red-600 dark:text-red-500",
  },
};

const QuickAccessCard = ({leaveCount}) => {
  const navigate = useNavigate();

  const handleClick = (item) => {
    if (item.route) {
      navigate(item.route, {
        state: { fromQuickAccess: true }
      });
    }
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {shortCuts.map((item) => {
        const color = colorMap[item.color];
        const badgeText = item.id === 4 ? `${leaveCount} Pending` : item.badge;

        return (
          <Card
            key={item.id}
            onClick={() => handleClick(item)}
            className={`flex flex-col rounded-xl cursor-pointer border-2 ${color.border} bg-gradient-to-br ${color.light} group hover:shadow-xl`}
          >
            {badgeText && (
              <div className="absolute top-2 right-2">
                <span className="text-xs inline-flex items-center justify-center rounded-xl border font-medium w-fit px-1 py-0.5 text-white bg-red-500 animate-pulse">
                  {badgeText}
                </span>
              </div>
            )}
            <div className="flex items-center justify-between mb-10">
              <div
                className={`p-3 rounded-2xl bg-gradient-to-br ${color.header} shadow-lg group-hover:scale-110 ease-in-out duration-300`}
              >
                {item.icon}
              </div>
              <ChevronRight className={`w-5 h-5 ${color.chevron} group-hover:translate-x-1 transition-transform`} />
            </div>
            <div>
              <h4 className={`text-[16px] mb-2 font-medium ${color.text}`}>
                {item.title}
              </h4>
              <p className={`text-[12px] ${color.desc}`}>{item.description}</p>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default QuickAccessCard;
